import { UserFormValues } from '../containers';

type ValidationErrors = Record<string, string[] | undefined>;

type ValidationOptions = {
  mode: 'create' | 'edit';
};

export const validateUser =
  ({ mode }: ValidationOptions) =>
  async (values: UserFormValues): Promise<ValidationErrors> => {
    const errors: ValidationErrors = {};
    const isCreate = mode === 'create';

    if (!values.firstName) {
      errors.firstName = ['The firstName is required'];
    }

    if (!values.lastName) {
      errors.lastName = ['The lastName is required'];
    }

    if (!values.email) {
      errors.email = ['The email is required'];
    }

    if (!values.primaryPhone) {
      errors.primaryPhone = ['The primary phone number is required'];
    }

    if (!values.idNumber) {
      errors.idNumber = ['The id number is required'];
    }

    if (!values.selectedRoles || values.selectedRoles.length === 0) {
      errors.selectedRoles = ['The Role is required'];
    }

    if (!values.selectedRegions || values.selectedRegions.length === 0) {
      errors.selectedRegions = ['The Region is required'];
    }

    if (isCreate && !values.password) {
      errors.password = ['The password is required'];
    }

    return errors;
  };

